var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t("contract.venue_governing_law.headline")))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t("contract.venue_governing_law.paragraph_one")))]),_vm._v(" "),(!_vm.eeaOrEu)?_c('p',[_vm._v(_vm._s(_vm.$t("contract.venue_governing_law.paragraph_two")))]):_c('p',[_vm._v(_vm._s(_vm.$t("contract.venue_governing_law.paragraph_two_alternate")))]),_vm._v(" "),_c('hr')])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/eneforhandler/components/contract/VenueGoverningLawOutput.vue?vue&type=template&id=dde05266&
// module id = null
// module chunks = 